import { isEligibleCampaignResult } from "@dashboardApi/apis/engagementCampaignsEligible/validators";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { EligibleCampaignResponse, GetEligibleCampaignsParams } from "./types";

export const getEligibleCampaigns = reactQueryFetcherAdapter(
  cacheKey,
  async (
    signal,
    appGroupId: string,
    { query, limit = 250, currentCampaignId, interaction }: GetEligibleCampaignsParams
  ): Promise<EligibleCampaignResponse> => {
    return fetch(
      `/engagement/campaigns/${appGroupId}/eligible`,
      "GET",
      {
        query,
        limit,
        current_campaign_id: currentCampaignId,
        interaction,
      },
      { signal }
    );
  },
  isEligibleCampaignResult
);
